import React, { useEffect } from "react";
import Page from "components/common/page/Page.component";
import WarningListContainer from "containers/dashboard/warning-list/WarningList.container";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const VISITOR = "visitor";

const WarningListPage = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (user && user.role === VISITOR) {
      navigate("/404");
    }
    // eslint-disable-next-line
  }, [user]);

  return (
    <Page title="Elenco allarmi">
      {user.role !== VISITOR && <WarningListContainer />}{" "}
    </Page>
  );
};

export default WarningListPage;
